import { AxiosInstance } from 'axios';
import RepeatableEventsRepositoryInterface, {
  ApiCreateRepeatableEventsInterface,
  ApiUpdateRepeatableEventsInterface,
  RepeatableEventsInterface,
} from '@/services/Calendar/RepeatableEvents/Interfaces';


export default class RepeatableEventsRepository implements RepeatableEventsRepositoryInterface {
  private apiPrefix = '/event-calendar/repeatable-event';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllRepeatableEvents(): Promise<RepeatableEventsInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getRepeatableEvent(id: number): Promise<RepeatableEventsInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/event/${id}`);

    return res.data;
  }

  public async createRepeatableEvent(data: ApiCreateRepeatableEventsInterface): Promise<boolean> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.status === 201;
  }

  public async updateRepeatableEvent(data: ApiUpdateRepeatableEventsInterface): Promise<void> {
    await this.axios.patch(this.apiPrefix, data);
  }

  public async deleteRepeatableEvent(id: number): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { id } });
  }
}
